import React from 'react';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet";
import {Animated} from "react-animated-css";

const Home = () => (
  <Animated animationIn="fadeIn">
    <Helmet>
      <title>GongIdeas | Let's imagine come true.</title>
    </Helmet>
    <div className="container-fluid py-5">
      <p>
        สวัสดีครับ ผมก้อง เป็น Freelance Programmer<br />
        มีประสบการณ์ทำเวบไซต์มากกว่า 10 ปี ทั้งเวบบริษัท ทั้งเวบขายของ และเวบสำหรับระบบงานภายในบริษัท<br />
        ถ้าสนใจ ติดต่อเข้ามาคุยรายละเอียดกันก่อนได้นะครับ
      </p>
      <div className="py-4">
        <Animated animationIn="fadeInRight" animationInDelay="1000" className="d-inline-block">
        <Link className="btn-outline" to='/portfolios'>ดูผลงาน</Link>
        </Animated>
        <Animated animationIn="fadeInRight" animationInDelay="1300" className="d-inline-block">
          <Link className="btn-outline" to='/contact'>ติดต่อสอบถาม</Link>
        </Animated>
      </div>
    </div>
  </Animated>
);

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js